export const calculateModulesOverage = (modules: number, modulesInBundle: number): number => {
  const remainingModules = modules % modulesInBundle;

  if (remainingModules > 0) {
    return modulesInBundle - remainingModules;
  }

  return 0;
};
